import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SupplierFilterSupplier,
  SupplierCreateSupplier,
  SupplierUpdateSupplier,
  SupplierFilterSupplierType,
  CompanyManageMyCompany,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function SupplierAE() {
  const [isLoading, setLoading] = useState(true);
  const [SupplierType, setSupplierType] = useState([]);
  const [myCompany, setMyCompany] = useState([]);
  const [parentSupplier, setParentSupplier] = useState([]);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();

  const start = async () => {
    try {
      const SupplierFilterSuppliertData = await SupplierFilterSupplier({});
      if (
        SupplierFilterSuppliertData.status &&
        SupplierFilterSuppliertData.status === 200
      ) {
        setParentSupplier(SupplierFilterSuppliertData.data.data.data);
      }
      if (id) {
        const SupplierFilterSuppliertData = await SupplierFilterSupplier({
          id: id,
        });
        if (
          SupplierFilterSuppliertData.status &&
          SupplierFilterSuppliertData.status === 200
        ) {
          setForm(SupplierFilterSuppliertData.data.data.data[0]);
        }
      }
      const SupplierFilterSupplierTypeData = await SupplierFilterSupplierType(
        {}
      );
      if (
        SupplierFilterSupplierTypeData.status &&
        SupplierFilterSupplierTypeData.status === 200
      ) {
        setSupplierType(SupplierFilterSupplierTypeData.data.data.data);
        const CompanyManageMyCompanyData = await CompanyManageMyCompany({});
        if (
          CompanyManageMyCompanyData.status &&
          CompanyManageMyCompanyData.status === 200
        ) {
          setMyCompany(CompanyManageMyCompanyData.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.description === "") {
      toast.error("توضیحات را وارد نمایید ");
      validation = false;
    }
    if (form.nationalId === "") {
      toast.error("کد را وارد نمایید ");
      validation = false;
    }
    if (form.companyId === "") {
      toast.error("شرکت را وارد نمایید ");
      validation = false;
    }
    if (form.supplierTypeId === "") {
      toast.error("نوع را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const SupplierUpdateSupplierData = await SupplierUpdateSupplier(form);
          if (
            SupplierUpdateSupplierData.status &&
            SupplierUpdateSupplierData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Suppliers");
          }
        } else {
          const SupplierCreateSupplierData = await SupplierCreateSupplier(form);
          if (
            SupplierCreateSupplierData.status &&
            SupplierCreateSupplierData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Suppliers");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center w-100 m-2">
              <InputCus
                className="m-2"
                width="550px"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                width="550px"
                type="text"
                name="description"
                id="description"
                text="توضیحات"
                value={form.description || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                width="550px"
                type="text"
                name="symbol"
                id="symbol"
                text="سیمبل"
                value={form.symbol || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                width="550px"
                type="text"
                name="nationalId"
                id="nationalId"
                text="کد"
                value={form.nationalId || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center flex-wrap">
              <Select
                className="m-2"
                type="number"
                name="companyId"
                id="companyId"
                text="شرکت"
                value={form.companyId || ""}
                onChange={handleChangeSearch}
                option={myCompany.map((item) => {
                  let data = {
                    value: item.companyId,
                    title: item.companyName,
                  };
                  return data;
                })}
              />
              <Select
                className="m-2"
                type="number"
                name="supplierTypeId"
                id="supplierTypeId"
                text="نوع"
                value={form.supplierTypeId || ""}
                onChange={handleChangeSearch}
                option={SupplierType.map((item) => {
                  let data = {
                    value: item.id,
                    title: item.name,
                  };
                  return data;
                })}
              />
              <Select
                className="m-2"
                type="number"
                name="ParentId"
                id="ParentId"
                text="پدر"
                value={form.ParentId || ""}
                onChange={handleChangeSearch}
                option={parentSupplier.map((item) => {
                  let data = {
                    value: item.id,
                    title: item.name,
                  };
                  return data;
                })}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierAE;
